module.exports = __webpack_public_path__ + "static/media/img_productosvarios.7bef4ab2.jpg";